import React, { useState, useEffect } from "react";
import axios from "axios";
import axiosInstance from '../../config/axiosInterceptor'
import { toast } from "react-toastify";
import * as XLSX from 'xlsx';
// import "react-datepicker/dist/react-datepicker.css";

const PKBattleComponent = () => {
  const [rounds, setRounds] = useState([]);
  const [activeRound, setActiveRound] = useState(null);
  const [rankings, setRankings] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalOpenSettle, setModalOpenSettle] = useState(false);
  const [matchModalOpen, setMatchModalOpen] = useState(false);
  const [matchSendStars, setMatchSendStars] = useState(false);
  const [transList, setTransList] = useState([]);
  const [modaltransList, setmodalTransList] = useState(false);
  const [matchType, setMatchType] = useState("withdrawal");
  const [maxPerDay, setMaxPerDay] = React.useState(0);
  const [matchDateTime, setMatchDateTime] = useState("");
  const [month, setMonth] = useState(new Date().getMonth());
  const [year, setYear] = useState(new Date().getFullYear());
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10); // Adjust limit as needed
  const [totalPages, setTotalPages] = useState(1);
  const [totalCount, setTotalCount] = useState(0);
  const months = [
    "January", "February", "March", "April", "May", "June",
    "July", "August", "September", "October", "November", "December"
  ];
  const [newRoundData, setNewRoundData] = useState({
    roundName: "",
    familyPoint: "",
    maxMembers: "",
    startDate: "",
    endDate: "",
    image: null,
  });
  const [newSettle, setNewSettle] = useState({
    points: 0,
    winner: "0",
    id: "",
    familyPkId: ""
  });

  // Admin Family Management States
  const [families, setFamilies] = useState([]);
  const [selectedFamily, setSelectedFamily] = useState(null);
  const [familyMembers, setFamilyMembers] = useState([]);
  const [selectedMembers, setSelectedMembers] = useState([]);
  const [familyModalOpen, setFamilyModalOpen] = useState(false);
  const [registerFamilyModalOpen, setRegisterFamilyModalOpen] = useState(false);
  const [viewMembersModalOpen, setViewMembersModalOpen] = useState(false);
  const [familySearch, setFamilySearch] = useState("");
  const [memberSearch, setMemberSearch] = useState("");
  const [familyPage, setFamilyPage] = useState(1);
  const [memberPage, setMemberPage] = useState(1);
  const [memberLimit, setMemberLimit] = useState(10);
  const [memberTotalPages, setMemberTotalPages] = useState(1);
  const [memberTotalCount, setMemberTotalCount] = useState(0);
  const [registeredUsersModal, setRegisteredUsersModal] = useState(false);
  const [registeredUsers, setRegisteredUsers] = useState([]);
  const [addRegistrationModalOpen, setAddRegistrationModalOpen] = useState(false);

  useEffect(() => {
    fetchRounds();
  }, [month, year]);

  const fetchRounds = async () => {
    console.log("fetchRounds called");
    setLoading(true)
    await axiosInstance.get(`${process.env.REACT_APP_BASEURL5}/admin/familypk/getRounds?month=${month}&year=${year}`).then((response) => {
      if (response.data.success === 1) {
        toast.success(response.data.message);
        const roundsData = response.data.data || [];
        setRounds(roundsData);
        
        // Set the first round as active round if available
        if (roundsData.length > 0) {
          console.log("Setting activeRound to:", roundsData[0]);
          setActiveRound(roundsData[0]);
          fetchRankings(roundsData[0]);
        }
        setLoading(false)
      } else {
        toast.error(response.data.error);
      }
    }).catch((error) => {
      toast.error(error.message)
      console.error("Error fetching rounds:", error);
    })
  };
  const fetchTransList = async () => {
    try {
      await axiosInstance.get(`${process.env.REACT_APP_BASEURL5}/admin/familypk/getSendStarHistory?page=${page}&limit=${500}&familyPkId=${activeRound?._id}`).then((res) => {
        if (res.data.success === 1) {
          toast.success(res.data.message);
          setTransList(res.data.history || []);
        }
      })
    } catch (error) {
      toast.error(error.message)
      console.error("Error fetching rounds:", error);
    }
  };

  const exportToExcel = async () => {
    try {
      // Fetch all transactions without pagination
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_BASEURL5}/admin/familypk/getSendStarHistory?page=1&limit=10000&familyPkId=${activeRound?._id}`
      );
      
      if (response.data.success === 1) {
        const data = response.data.history || [];
        
        // Prepare data for Excel
        const excelData = data.map((item, index) => ({
          'S.No': index + 1,
          'Family Name': item.familyName || 'N/A',
          'Family ID': item.familyId || 'N/A',
          'Username': item.username || 'N/A',
          'User ID': item.userId || 'N/A',
          'Receiving Value': item.receivingValue || item.stars || 0,
          'Type': item.type || 'stars',
          'Date': new Date(item.createdAt).toLocaleString('en-IN', { timeZone: 'Asia/Kolkata' })
        }));

        // Create worksheet
        const worksheet = XLSX.utils.json_to_sheet(excelData);
        
        // Set column widths
        const columnWidths = [
          { wch: 8 },  // S.No
          { wch: 25 }, // Family Name
          { wch: 30 }, // Family ID
          { wch: 20 }, // Username
          { wch: 30 }, // User ID
          { wch: 15 }, // Receiving Value
          { wch: 15 }, // Type
          { wch: 25 }  // Date
        ];
        worksheet['!cols'] = columnWidths;

        // Create workbook
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, 'Transactions');

        // Generate filename
        const filename = `family_pk_transactions_${activeRound?.roundName || 'round'}_${Date.now()}.xlsx`;

        // Download file
        XLSX.writeFile(workbook, filename);
        toast.success('Excel file downloaded successfully!');
      } else {
        toast.error('Failed to fetch transaction data');
      }
    } catch (error) {
      toast.error(error.message);
      console.error('Error exporting to Excel:', error);
    }
  };
  const handlePageChange = (newPage) => {
    setPage(newPage);
  };
  const handleLimitChange = (event) => {
    setLimit(Number(event.target.value));
    setPage(1); // Reset to the first page when changing the limit
  };
  useEffect(() => {
    if (activeRound) {
      fetchRankings(activeRound._id);
    }
  }, [page, limit, activeRound]);
  const fetchRankings = async (round) => {
    try {
      setLoading(true)
      await axiosInstance.get(
        `${process.env.REACT_APP_BASEURL5}/admin/familypk/getRegisteredPks?familyPkId=${round}&page=${page}&limit=${limit}&month=${month}&year=${year}`
      ).then((response) => {
        if (response.data.success === 1) {
          setRankings(response.data.data || []);
          setTotalPages(response.data.totalPages || []);
          setTotalCount(response.data.totalCount || []);
          setLoading(false)
        }
      })
    } catch (error) {
      console.error("Error fetching rankings:", error);
    }
  };

  const handleAddRound = async () => {
    try {
      const formData = new FormData();
      Object.keys(newRoundData).forEach((key) => {
        formData.append(key, newRoundData[key]);
      });

      const response = await axiosInstance.post(
        `${process.env.REACT_APP_BASEURL5}/admin/familypk/createPkRound`,
        formData,
        { headers: { "Content-Type": "multipart/form-data" } }
      );
      alert(response.data.message);
      setModalOpen(false);
      fetchRounds();
    } catch (error) {
      toast.error(error.message)
      console.error("Error creating round:", error);
    }
  };
  const handleSettle = async () => {
    try {
      // const formData = new FormData();
      // Object.keys(newSettle).forEach((key) => {
      //   formData.append(key, newSettle[key]);
      // });
      let conf = window.confirm(
        "Are you sure you want to settle manually. This will reflect in app"
      );
      if (conf == false) {
        return;
      }
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_BASEURL5}/admin/familypk/settleFamilyPk`,
        newSettle,
        // { headers: { "Content-Type": "multipart/form-data" } }
      );
      alert(response.data.message);
      setModalOpenSettle(false);
      fetchRounds();
    } catch (error) {
      toast.error(error.message)
      console.error("Error creating round:", error);
    }
  };
  const handleMatchUsers = async () => {
    try {
      if (new Date(matchDateTime) <= new Date()) {
        alert("Please select a future date and time.");
        return;
      }

      const response = await axiosInstance.post(
        `${process.env.REACT_APP_BASEURL5}/admin/familypk/matchUserAlgo`,
        { familyPkId: activeRound?._id, matchType, matchDateTime,maxPerDay }
      );
      alert(response.data.message);
      setMatchModalOpen(false);
    } catch (error) {
      toast.error(error.message)
      console.error("Error matching users:", error);
    }
  };
  const handleSettleAll = async (firstPk) => {
    try {
      // const formData = new FormData();
      // Object.keys(newSettle).forEach((key) => {
      //   formData.append(key, newSettle[key]);
      // });
      if (!firstPk) {
        alert('Pk not exist')
        return;
      }
      let conf = window.confirm(
        "Are you sure you want to settle manually. This will reflect in app"
      );
      if (conf == false) {
        return;
      }
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_BASEURL5}/admin/familypk/updateFamilyPks`,
        {firstPk},
        // { headers: { "Content-Type": "multipart/form-data" } }
      );
      alert(response.data.message);


    } catch (error) {
      console.error("Error creating round:", error);
      alert(error.message);
    }
  };
  const [type, setType] = React.useState("HOST");
  const [sendType, setSendType] = React.useState("stars");
  const [pickFrom, setPickFrom] = React.useState("registration");
  const handleSendStars = async (amount, type) => {
    try {
      let conf = window.confirm(
        `Are you sure you want to send stars? Your entered amount is ${amount}`
      );
      if (!conf) {
        return;
      }
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_BASEURL5}/admin/familypk/sendStars`,
        { familyPkId: activeRound?._id, amount, type, sendType, pickFrom }
      ).then((res) => {
        toast.success(res.data.message);
        alert(res.data.message);
        setMatchSendStars(false);
      });
    } catch (error) {
      toast.error(error.message);
      console.error("Error matching users:", error);
    }
  };
  const handleDeductStars = async (id) => {
    try {
      let conf = window.confirm(
        "Are you sure you want to deduct stars"
      );
      if (conf == false) {
        return;
      }
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_BASEURL5}/admin/familypk/returnStars`,
        { id: id }
      );
      alert(response.data.message);
    } catch (error) {
      toast.error(error.message)
      console.error("Error matching users:", error);
    }
  };
  const approveRej = async (type) => {
    try {
      let conf = window.confirm(
        "Are you sure you want to " + (type == "1" ? "approve " : "reject ") + "Matched users"
      );
      if (conf === true) {
        if (type == "1") {
          let conf2 = window.confirm("This will start event on app");
          if (conf2 === false) return;
        }
      } else {
        return;
      }

      await axiosInstance.post(
        `${process.env.REACT_APP_BASEURL5}/admin/familypk/approveRej`,
        { familyPkId: activeRound?._id, type: type }
      ).then((res) => {
        console.log(res);
        toast.success(res.data.message);
      }).catch((e) => console.log(e));
    } catch (error) {
      toast.error(error.message)
      console.error("Error matching users:", error);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewRoundData({ ...newRoundData, [name]: value });
  };
  const handleInputChangeSettle = (e) => {
    const { name, value } = e.target;
    setNewSettle({ ...newSettle, [name]: value });
  };

  const handleFileChange = (e) => {
    setNewRoundData({ ...newRoundData, image: e.target.files[0] });
  };
  const [selectAll, setSelectAll] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const toggleSelectAll = () => {
    if (selectAll) {
      setSelectedItems([]);
    } else {
      const allFamilyIds = rankings.map(item => item.familyId);
      setSelectedItems(allFamilyIds);
    }
    setSelectAll(!selectAll);
  };

  const handleCheckboxChange = (item) => {
    const isSelected = selectedItems.some(selected => selected === item);
    if (isSelected) {
      setSelectedItems(selectedItems.filter(selected => selected !== item));
    } else {
      setSelectedItems([...selectedItems, item]);
    }
  };
  const handleSelectedAction = async () => {
    if (selectedItems.length === 0) {
      alert("Please select at least one row.");
      return;
    }

    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_BASEURL5}/admin/familypk/egligibleSet`,
        { egligibleIds: selectedItems, familyPkId: activeRound._id }
      );
      alert(response.data.message);
      setSelectedItems([]); // Clear selected rows
    } catch (error) {
      console.error("Error performing action on selected rows:", error);
    }
  };

  const [isEditing, setIsEditing] = useState("");
  const [selectedDateTime, setSelectedDateTime] = useState();

  const handleEditClick = (id) => {
    setIsEditing(id);
  };

  const handleDateChange = (event) => {
    setSelectedDateTime(event.target.value);
  };

  const handleSubmit = async (id) => {
    setIsEditing(false);

    const date = new Date(selectedDateTime);
    const formattedDateTime = `${(date.getMonth() + 1)
      .toString()
      .padStart(2, "0")}/${date.getDate().toString().padStart(2, "0")}/${date.getFullYear()} ${date
        .getHours()
        .toString()
        .padStart(2, "0")}:${date.getMinutes().toString().padStart(2, "0")}`;

    await updateDateTime(isEditing, formattedDateTime);
  };
  const updateDateTime = async (id, dateTime) => {
    let conf = window.confirm(
      "Are you sure you want to update date "
    );
    if (conf === false) return;
    try {
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_BASEURL5}/admin/familypk/updateDate`,
        { id, dateTime }
      );
      alert(response.data.message);
      // setSelectedItems([]); // Clear selected rows
    } catch (error) {
      toast.error(error.message)
      console.error("Error performing action on selected rows:", error);
    }
  };

  // Admin Family Management Functions
  const fetchFamilies = async (page = 1, search = "") => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_BASEURL5}/admin/familypk/getAllFamilies?page=${page}&limit=10&search=${search}`
      );
      
      if (response.data.success === 1) {
        setFamilies(response.data.data || []);
        toast.success(response.data.message);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error("Error fetching families: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchFamilyMembers = async (familyId, search = "", page = memberPage) => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_BASEURL5}/admin/familypk/getFamilyMembers?familyId=${familyId}&page=${page}&limit=${memberLimit}&search=${search}`
      );
      
      if (response.data.success === 1) {
        setFamilyMembers(response.data.data.members || []);
        setMemberTotalPages(response.data.pagination?.totalPages || 1);
        setMemberTotalCount(response.data.pagination?.totalCount || 0);
        toast.success(response.data.message);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error("Error fetching family members: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchRegisteredUsers = async (familyPkId, familyId) => {
    console.log("fetchRegisteredUsers called with:");
    console.log("familyPkId:", familyPkId);
    console.log("familyId:", familyId);
    
    if (!familyPkId || !familyId) {
      toast.error("Missing required parameters: familyPkId or familyId");
      return;
    }
    
    try {
      const response = await axiosInstance.get(
        `${process.env.REACT_APP_BASEURL5}/admin/familypk/getRegisteredUsersForPk?familyPkId=${familyPkId}&familyId=${familyId}`
      );
      
      console.log("fetchRegisteredUsers response:", response.data);
      
      if (response.data.success === 1) {
        setRegisteredUsers(response.data.data || []);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      console.error("fetchRegisteredUsers error:", error);
      toast.error("Error fetching registered users: " + error.message);
    }
  };

  const adminRegisterPkBattle = async () => {
    if (!activeRound?._id || !selectedFamily || selectedMembers.length === 0) {
      toast.warning("Please select family and members");
      return;
    }

    try {
      setLoading(true);
      const response = await axiosInstance.post(
        `${process.env.REACT_APP_BASEURL5}/admin/familypk/adminRegisterPkBattle`,
        {
          familyPkId: activeRound._id,
          familyId: selectedFamily._id,
          userId: selectedMembers
        }
      );
      
      if (response.data.success === 1) {
        toast.success(response.data.message);
        setRegisterFamilyModalOpen(false);
        setAddRegistrationModalOpen(false);
        setSelectedMembers([]);
        setSelectedFamily(null);
        setFamilyMembers([]);
        setFamilySearch("");
        fetchRankings(activeRound._id);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error("Error registering PK battle: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const deleteFamilyPkRegistration = async (familyPkId, familyId) => {
    if (!window.confirm("Are you sure you want to delete this PK registration?")) {
      return;
    }

    try {
      setLoading(true);
      const response = await axiosInstance.delete(
        `${process.env.REACT_APP_BASEURL5}/admin/familypk/deletePkRegistration`,
        {
          data: { familyPkId, familyId }
        }
      );
      
      if (response.data.success === 1) {
        toast.success(response.data.message);
        fetchRegisteredUsers(familyPkId, familyId);
        fetchRankings(activeRound._id);
      } else {
        toast.error(response.data.message);
      }
    } catch (error) {
      toast.error("Error deleting PK registration: " + error.message);
    } finally {
      setLoading(false);
    }
  };

  const handleMemberSelection = (memberId) => {
    setSelectedMembers(prev => {
      if (prev.includes(memberId)) {
        return prev.filter(id => id !== memberId);
      } else {
        return [...prev, memberId];
      }
    });
  };

  // Search functions
  const handleFamilySearch = () => {
    fetchFamilies(1, familySearch);
  };

  const handleMemberSearch = () => {
    if (selectedFamily) {
      setMemberPage(1); // Reset to first page when searching
      fetchFamilyMembers(selectedFamily._id, memberSearch, 1);
    }
  };

  // Member pagination handlers
  const handleMemberPageChange = (newPage) => {
    setMemberPage(newPage);
    if (selectedFamily) {
      fetchFamilyMembers(selectedFamily._id, memberSearch, newPage);
    }
  };

  const handleMemberLimitChange = (newLimit) => {
    setMemberLimit(newLimit);
    setMemberPage(1);
    if (selectedFamily) {
      fetchFamilyMembers(selectedFamily._id, memberSearch, 1);
    }
  };

  return (
    <div className="container py-4 ">
      {/* Month and Year Dropdown */}
      {activeRound && (
        <section className="content">
          <div
            className="row"
            style={{ display: "flex", justifyContent: "between" }}
          >
            <div className="col-md-10 col-12">
              <div className="box box-warning">
                {/* Event Images Section */}
                <div
                  className="box-header with-border"
                  style={{ display: "flex", alignItems: "center" }}
                >
                <div style={{ display: "flex", gap: "40px" }}>
                  <div>
                    {activeRound?.image && (
                      <img
                        src={activeRound.image}
                        alt="Event"
                        style={{
                          width: "400px",
                          height: "200px",
                          borderRadius: "2%",
                        }}
                      />
                    )}
                  </div>
                </div>

                {/* Event Details Section */}
                <div style={{ marginLeft: "40px" }}>
                  <h3>Round Name: {activeRound?.roundName}</h3>
                  <h4>Round Code: {activeRound?._id}</h4>
                  <h4>Family Points: {activeRound?.familyPoint}</h4>
                  <h4>Max Members: {activeRound?.maxMembers}</h4>
                  <p>
                    Reg Time: {activeRound?.startDate} to {activeRound?.endDate}
                  </p>
                  <button
                    className={`btn ${activeRound?.egligibleSet === "1"
                      ? "btn-success"
                      : "btn-danger"
                      }`}
                  >
                    {activeRound?.egligibleSet === "1"
                      ? "Eligible Set"
                      : "Not-Eligible Set"}
                  </button>
                  <button
                    className={`btn ${activeRound?.live === "1"
                      ? "btn-success"
                      : "btn-danger"
                      }`}
                  >
                    {activeRound?.live === "1"
                      ? "AppLive"
                      : "Not-AppLive"}
                  </button>
                  <button style={{ margin: "0 100%" }} className="btn btn-success" onClick={() => setMatchSendStars(true)}>
                    Send Stars
                  </button>
                  <button style={{ margin: "0 100%" }} className="btn btn-warning" onClick={() => { setmodalTransList(true); fetchTransList() }}>
                    Transaction List
                  </button>
                  <button style={{ margin: "0 100%" }} className="btn btn-info" onClick={exportToExcel}>
                    Export to Excel
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      )}
      
      {!activeRound && rounds.length === 0 && !loading && (
        <div className="alert alert-info text-center">
          <h4>No PK Rounds Available</h4>
          <p>No rounds found for the selected month and year. Please select a different time period or create a new round.</p>
        </div>
      )}
      
      {!activeRound && rounds.length > 0 && (
        <div className="alert alert-warning text-center">
          <h4>Select a Round</h4>
          <p>Please select a round from the navigation below to view details.</p>
        </div>
      )}
      
      {/* Month and Year Dropdown */}
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div style={{ marginBottom: "20px", marginTop: "20px" }}>
          <select style={{ padding: "8px", marginLeft: "8px" }}
            value={month}
            onChange={(e) => setMonth(Number(e.target.value))}
            className="form-select d-inline w-auto me-2"
          >
            {months.map((m, index) => (
              <option key={index} value={index}>
                {m}
              </option>
            ))}
          </select>
          <select style={{ padding: "8px", marginLeft: "8px" }}
            value={year}
            onChange={(e) => setYear(Number(e.target.value))}
            className="form-select d-inline w-auto"
          >
            {Array.from(
              { length: 10 },
              (_, i) => new Date().getFullYear() - 5 + i
            ).map((yr) => (
              <option key={yr} value={yr}>
                {yr}
              </option>
            ))}
          </select>
        </div>
      </div>
      {/* Round Navigation */}
      <div className="d-flex w-full flex-row justify-content-between align-items-center mb-4">
        <div>
          {rounds.map((round, index) => (
            <button style={{ marginRight: "10px" }}
              key={index}
              className={`btn btn-outline-primary mx-1 ${activeRound?._id === round._id ? "active btn-warning " : ""
                }`}
              onClick={() => { setActiveRound(round); fetchRankings(round) }}
            >
              Round {index + 1}
            </button>
          ))}
          <button
            className="btn btn-primary"
            onClick={() => setModalOpen(true)}
          >
            Add Round
          </button>
        </div>
        {activeRound?.matched == "0" ? <button style={{ marginBottom: "20px", marginTop: "20px", display: "flex", justifyContent: "flex-end" }}
          className=" btn btn-info"
          onClick={() => setMatchModalOpen(true)}
        >
          Match Users
        </button> : <div style={{ marginBottom: "20px", marginTop: "20px", display: "flex", justifyContent: "flex-end" }}>
          <button
            className="btn btn-success"
            onClick={() => approveRej("1")}
          >
            Approve
          </button>
          <button
            className="btn btn-danger"
            onClick={() => approveRej("2")}
          >
            Reject
          </button>
        </div>}
      </div>
      {rankings.length > 0 && selectedItems.length > 0 && <div className="mb-4">
        <button style={{ margin: "0 50%" }} className="btn btn-success" onClick={handleSelectedAction}>
          Submit for Next round
        </button>
      </div>}

      {/* Add Registration Button */}
      {activeRound && (
        <div className="mb-4 text-center">
          <button 
            className="btn btn-primary btn-lg"
            onClick={() => {
              setAddRegistrationModalOpen(true);
              fetchFamilies(1, "");
              setFamilyPage(1);
            }}
          >
            <i className="fas fa-plus me-2"></i>
            Add New Registration
          </button>
        </div>
      )}

      {/* Dropdown for Entries Per Page */}
      <div style={{ marginBottom: "20px", marginTop: "20px" }} className="d-flex justify-content-between align-items-center mb-3">
        <label htmlFor="entriesPerPage" className="me-2">
          Entries Per Page:
        </label>
        <select style={{ padding: "8px", marginLeft: "8px" }}
          id="entriesPerPage"
          className="form-select w-auto"
          value={limit}
          onChange={handleLimitChange}
        >
          <option value={10}>10</option>
          <option value={50}>50</option>
          <option value={100}>100</option>
        </select>
      </div>

      {/* Pagination Controls */}
      <div style={{ display: "flex", alignItems: "center", justifyContent: "center", fontSize: "16px" }} className="d-flex justify-content-center my-3">
        <button
          className="btn btn-secondary"
          disabled={page === 1}
          onClick={() => handlePageChange(page - 1)}
        >
          Previous
        </button>
        <span className="mx-2 align-self-center">
          Page {page} of {totalPages}
        </span>
        <button
          className="btn btn-secondary"
          disabled={page === totalPages}
          onClick={() => handlePageChange(page + 1)}
        >
          Next
        </button>
        <div style={{ marginLeft: "10px", fontWeight: "bold" }}>Total:{totalCount}</div>
      </div>
      {/* Rankings Table */}
      <div className="table-responsive">
        {rounds.length > 0 ? <table className="table table-bordered table-striped">
          <thead className="table-dark">
            <tr>
              <th>
                <input
                  type="checkbox"
                  onChange={toggleSelectAll}
                  checked={selectAll}
                />
              </th>
              <th>Rank</th>
              <th>Family Name</th>
              <th>Leader</th>
              <th>Status</th>
              <th>StartTime</th>
              <th>Host Name</th>
              <th>VS</th>
              <th>Opponent Family</th>
              <th>Date/Time</th>
              <th>Winner</th>
              <th>Receive Star</th>
              <th>Slap Point</th>
              <th>Winning Point</th>
              <th>Total Point</th>
              <th>Action</th>
              <th>Registration</th>
            </tr>
          </thead>
          <tbody>
            {loading ? "Loading..." : rankings?.map((rank, index) => {
              // Calculate totals for the current host group
              const totalReceivingStars = rank?.host?.reduce((sum, item) => sum + (item?.receiveStars || 0), 0);
              const totalSlapPoints = rank?.host?.reduce((sum, item) => sum + (item?.slapPoints || 0), 0);
              const totalWinningPoints = rank?.host?.reduce((sum, item) => sum + (item?.winningPoints || 0), 0);
              const totalPoints = rank?.host?.reduce((sum, item) => sum + (item?.totalPoints || 0), 0);
              return (
                <React.Fragment key={index}>
                  <tr>
                    <td rowSpan={rank?.host?.length + 1}>
                      <input
                        type="checkbox"
                        checked={selectedItems.includes(rank.familyId)}
                        onChange={() => handleCheckboxChange(rank.familyId)}
                      />
                    </td>
                    <td rowSpan={rank?.host?.length + 1}>{(page - 1) * limit + index + 1}</td>
                    <td rowSpan={rank?.host?.length + 1}>{rank?.hostFamily?.name}</td>
                    <td rowSpan={rank?.host?.length + 1}>{rank?.hostFamily?.leader}</td>
                  </tr>
                  {rank?.host?.map((item, ind) => (
                    <tr key={ind}>
                      <td>
                        {item.liveStatus && (
                          <button
                            className={`btn ${item.liveStatus === "live"
                              ? "bg-success text-white"
                              : item.liveStatus === "upcoming"
                                ? "bg-warning text-white"
                                : item.liveStatus === "completed" && item.result == 0
                                  ? "bg-danger text-white"
                                  : item.liveStatus === "completed"
                                    ? "bg-blue text-white"
                                    : ""
                              }`}
                          >
                            {item.liveStatus === "completed" && item.result == 0
                              ? "Canceled"
                              : item.liveStatus.charAt(0).toUpperCase() + item.liveStatus.slice(1)}
                          </button>
                        )}
                      </td>
                      <td>{item.startTime ? new Date(item.startTime).toLocaleString() : ""}</td>
                      <td>{item?.host?.username}</td>
                      <td>{item?.host?.username} <div style={{ fontWeight: "bold", textAlign: "center" }}>VS</div> {item?.oponentHost?.username}</td>
                      <td>{item?.oponentFamily?.name}</td>
                      <td>
                        {isEditing === item?.roundId ? (
                          <div>
                            <input
                              type="datetime-local"
                              value={selectedDateTime}
                              onChange={handleDateChange}
                              className="date-input"
                            />
                            <button onClick={() => handleEditClick("")} className="submit-button">
                              Cancel
                            </button>
                            <button onClick={() => handleSubmit(item?.roundId)} className="submit-button">
                              Submit
                            </button>
                          </div>
                        ) : (
                          <div>
                            {item?.dateTime}
                            <span onClick={() => handleEditClick(item?.roundId)} style={{ cursor: "pointer", marginLeft: "8px" }}>
                              🖉
                            </span>
                          </div>
                        )}
                      </td>
                      <td>{item?.winner}</td>
                      <td>{item?.receiveStars || 0}</td>
                      <td>{item?.slapPoints || 0}</td>
                      <td>{item?.winningPoints || 0}</td>
                      <td>{item?.totalPoints || 0}</td>
                      <td className="btn btn-primary" style={{ marginTop: "16px" }} onClick={() => {
                        setNewSettle({ id: item?._id, familyPkId: activeRound?._id });
                        setModalOpenSettle(true)
                      }}>Edit</td>
                      <td className="btn btn-primary" style={{ marginTop: "16px" }} onClick={() => {
                        handleSettleAll(item?.firstPk)
                      }}>Settle</td>
                      {ind === 0 && (
                        <td rowSpan={rank?.host?.length}>
                          <div className="d-flex flex-column gap-1">
                            <button
                              className="btn btn-sm btn-info"
                              onClick={() => {
                                setSelectedFamily({ _id: rank.familyId, name: rank?.hostFamily?.name });
                                fetchRegisteredUsers(activeRound?._id, rank.familyId);
                                setRegisteredUsersModal(true);
                              }}
                            >
                              View Registered
                            </button>
                            <button
                              className="btn btn-sm btn-warning"
                              onClick={async () => {
                                setSelectedFamily({ _id: rank.familyId, name: rank?.hostFamily?.name });
                                await fetchFamilyMembers(rank.familyId);
                                // Fetch current registrations to pre-populate
                                try {
                                  const response = await axiosInstance.get(
                                    `${process.env.REACT_APP_BASEURL5}/admin/familypk/getRegisteredUsersForPk?familyPkId=${activeRound._id}&familyId=${rank.familyId}`
                                  );
                                  if (response.data.success === 1) {
                                    const currentMembers = response.data.data.map(reg => reg.user._id);
                                    setSelectedMembers(currentMembers);
                                  }
                                } catch (error) {
                                  console.error("Error fetching current registrations:", error);
                                }
                                setAddRegistrationModalOpen(true);
                              }}
                            >
                              Edit
                            </button>
                            <button
                              className="btn btn-sm btn-danger"
                              onClick={() => deleteFamilyPkRegistration(activeRound?._id, rank.familyId)}
                            >
                              Delete
                            </button>
                          </div>
                        </td>
                      )}
                    </tr>
                  ))}
                  {/* Add a totals row */}
                  <tr className="font-bold" style={{ backgroundColor: "#D5F3C4" }}>
                    <td colSpan={11}>Total</td>
                    <td>{totalReceivingStars}</td>
                    <td>{totalSlapPoints}</td>
                    <td>{totalWinningPoints}</td>
                    <td>{rank?.points}</td>
                    <td></td>
                  </tr>
                  <hr />
                </React.Fragment>
              )
            })}
          </tbody>

        </table> : "No Rounds found"}
      </div>

      {/* Match Users Modal */}
      {matchModalOpen && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Match Users</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setMatchModalOpen(false)}
                ></button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="mb-3">
                    <label className="form-label">Match Type</label>
                    <select
                      className="form-control"
                      value={matchType}
                      onChange={(e) => setMatchType(e.target.value)}
                    >
                      <option value="withdrawal">Withdrawal</option>
                      <option value="level">Level</option>
                      <option value="random">Random</option>
                    </select>
                  </div>
                  <div className="mb-3">
                  <label className="form-label">Max Per Day</label>
                  <input
                    type="number"
                    className="form-control"
                    value={maxPerDay}
                    onChange={(e) => setMaxPerDay(e.target.value)}
                    required
                  />
                </div>
                  <div className="mb-3">
                    <label className="form-label">Match Date & Time</label>
                    <input
                      type="datetime-local"
                      className="form-control"
                      value={matchDateTime}
                      onChange={(e) => setMatchDateTime(e.target.value)}
                      min={new Date().toISOString().slice(0, 16)} // Ensures only future date/time
                      required
                    />
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setMatchModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleMatchUsers}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Add Round Modal */}
      {modalOpen && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add New Round</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setModalOpen(false)}
                ></button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="mb-3">
                    <label className="form-label">Round Name</label>
                    <input
                      type="text"
                      className="form-control"
                      name="roundName"
                      value={newRoundData.roundName}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Family Points</label>
                    <input
                      type="number"
                      className="form-control"
                      name="familyPoint"
                      value={newRoundData.familyPoints}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Max Members</label>
                    <input
                      type="number"
                      className="form-control"
                      name="maxMembers"
                      value={newRoundData.maxMembers}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Start Date</label>
                    <input
                      type="datetime-local"
                      className="form-control"
                      name="startDate"
                      value={newRoundData.startDate}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">End Date</label>
                    <input
                      type="datetime-local"
                      className="form-control"
                      name="endDate"
                      value={newRoundData.endDate}
                      onChange={handleInputChange}
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Image</label>
                    <input
                      type="file"
                      className="form-control"
                      name="image"
                      onChange={handleFileChange}
                      required
                    />
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleAddRound}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {modalOpenSettle && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Edit Points</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setModalOpen(false)}
                ></button>
              </div>
              <div className="modal-body">
                <form>

                  <div className="mb-3">
                    <label className="form-label">Rec. Stars</label>
                    <input
                      type="number"
                      className="form-control"
                      name="points"
                      value={newSettle.points}
                      onChange={handleInputChangeSettle}
                      required
                    />
                  </div>
                  {/* Radio Button Group */}
                  <div className="mb-3">
                    <label className="form-label">Outcome</label>
                    <div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="winner"
                          value="1"
                          onChange={(e) =>
                            setNewSettle((prev) => ({ ...prev, winner: e.target.value }))
                          }
                          required
                        />
                        <label className="form-check-label">Winner</label>
                      </div>
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="radio"
                          name="winner"
                          value="0"
                          onChange={(e) =>
                            setNewSettle((prev) => ({ ...prev, winner: e.target.value }))
                          }
                          required
                        />
                        <label className="form-check-label">Loser</label>
                      </div>
                    </div>
                  </div>

                </form>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setModalOpenSettle(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={handleSettle}
                >
                  Submit
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {matchSendStars && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Send Stars</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setMatchSendStars(false)}
                ></button>
              </div>
              <div className="modal-body">
                <form>
                  <div className="mb-3">
                    <label className="form-label"> Stars</label>
                    <input
                      type="number"
                      className="form-control"
                      id="amount"
                      required
                    />
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Type</label>
                    <div>
                      <input
                        type="radio"
                        name="type"
                        value="HOST"
                        checked={type === "HOST"}
                        onChange={() => setType("HOST")}
                      /> Host
                      <input
                        type="radio"
                        name="type"
                        value="LEADER"
                        checked={type === "LEADER"}
                        onChange={() => setType("LEADER")}
                      /> Leader
                    </div>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Send Type</label>
                    <div>
                      <input
                        type="radio"
                        name="sendType"
                        value="stars"
                        checked={sendType === "stars"}
                        onChange={() => setSendType("stars")}
                      /> Stars
                      <input
                        type="radio"
                        name="sendType"
                        value="familypoints"
                        checked={sendType === "familypoints"}
                        onChange={() => setSendType("familypoints")}
                        style={{ marginLeft: "10px" }}
                      /> Family Points
                    </div>
                  </div>
                  <div className="mb-3">
                    <label className="form-label">Pick From</label>
                    <div>
                      <input
                        type="radio"
                        name="pickFrom"
                        value="registration"
                        checked={pickFrom === "registration"}
                        onChange={() => setPickFrom("registration")}
                      /> Registration
                      <input
                        type="radio"
                        name="pickFrom"
                        value="eligible"
                        checked={pickFrom === "eligible"}
                        onChange={() => setPickFrom("eligible")}
                        style={{ marginLeft: "10px" }}
                      /> Eligible
                    </div>
                  </div>
                </form>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setMatchSendStars(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={() => handleSendStars(document.getElementById("amount").value, type)}
                >
                  Send
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
      {
        modaltransList && (
          <div className="modal show d-block" tabIndex="-1">
            <div className="modal-dialog modal-lg" >
              <div className="modal-content">
                <div className="modal-header">
                  <h5 className="modal-title">Transaction History</h5>
                  <button className="btn-close" onClick={() => setmodalTransList(false)}></button>
                </div>
                <div className="modal-body" style={{ maxHeight: "500px", overflow: "auto" }}>
                <table className="table table-bordered table-striped table-hover">
                  <thead className="table-dark">
                    <tr>
                      <th>S.No</th>
                      <th>Family Name</th>
                      <th>Username</th>
                      <th>Amount</th>
                      <th>Type</th>
                      <th>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                  {transList.map((item, index) => {
                    return (
                      <tr key={item._id}>
                        <td>{index + 1}</td>
                        <td>{item?.familyName || 'N/A'}</td>
                        <td>{item?.username || item?.userId?.username || 'N/A'}</td>
                        <td>{item?.stars}</td>
                        <td>
                          <span className={`badge ${item?.type === 'familypoints' ? 'bg-success' : 'bg-primary'}`}>
                            {item?.type === 'familypoints' ? 'Family Points' : 'Stars'}
                          </span>
                        </td>
                        <td>
                          {item?.type === 'stars' ? (
                            <button className="btn btn-sm btn-danger" onClick={() => handleDeductStars(item._id)}>Return</button>
                          ) : (
                            <span className="text-muted">-</span>
                          )}
                        </td>
                      </tr>
                    )
                  })}
                  </tbody>
                </table>
                </div>
                <div className="modal-footer">
                  <button className="btn btn-secondary" onClick={() => setmodalTransList(false)}>Close</button>
                </div>
              </div>
            </div>
          </div>
        )
      }

      {/* Family Management Modal */}
      {familyModalOpen && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Family Management</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setFamilyModalOpen(false)}
                ></button>
              </div>
              <div className="modal-body">
                {/* Search Families */}
                <div className="mb-3">
                  <div className="input-group">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search families..."
                      value={familySearch}
                      onChange={(e) => setFamilySearch(e.target.value)}
                      onKeyPress={(e) => e.key === 'Enter' && handleFamilySearch()}
                    />
                    <button 
                      className="btn btn-outline-primary" 
                      type="button" 
                      onClick={handleFamilySearch}
                    >
                      <i className="fas fa-search"></i>
                    </button>
                  </div>
                </div>
                
                {/* Debug Button */}
                <div className="mb-3">
                  <button
                    className="btn btn-info btn-sm"
                    onClick={() => {
                      console.log("=== DEBUG INFO ===");
                      console.log("activeRound:", activeRound);
                      console.log("activeRound type:", typeof activeRound);
                      console.log("activeRound._id:", activeRound?._id);
                      console.log("rounds:", rounds);
                      console.log("rounds length:", rounds.length);
                      alert(`Active Round: ${JSON.stringify(activeRound, null, 2)}`);
                    }}
                  >
                    🐛 Debug Current Round
                  </button>
                </div>

                {/* Families Table */}
                <div className="table-responsive" style={{ maxHeight: "400px", overflowY: "auto" }}>
                  <table className="table table-bordered table-striped">
                    <thead>
                      <tr>
                        <th>Family</th>
                        <th>Leader</th>
                        <th>Members</th>
                        <th>Actions</th>
                      </tr>
                    </thead>
                    <tbody>
                      {families.map((family) => (
                        <tr key={family._id}>
                          <td>
                            <div className="d-flex align-items-center">
                              <img
                                src={family.image || "/default-family.png"}
                                alt="Family"
                                className="rounded-circle me-2"
                                style={{ width: "40px", height: "40px" }}
                              />
                              <span>{family.name}</span>
                            </div>
                          </td>
                          <td>
                            <div className="d-flex align-items-center">
                              <img
                                src={family.leader.picture || "/default-avatar.png"}
                                alt="Leader"
                                className="rounded-circle me-2"
                                style={{ width: "30px", height: "30px" }}
                              />
                              <span>{family.leader.username}</span>
                            </div>
                          </td>
                          <td>
                            <span className="badge bg-primary">{family.memberCount}</span>
                          </td>
                          <td>
                            <button
                              className="btn btn-sm btn-info me-1"
                              onClick={() => {
                                setSelectedFamily(family);
                                fetchFamilyMembers(family._id);
                                setViewMembersModalOpen(true);
                              }}
                            >
                              View Members
                            </button>
                            <button
                              className="btn btn-sm btn-success me-1"
                              onClick={() => {
                                setSelectedFamily(family);
                                fetchFamilyMembers(family._id);
                                setRegisterFamilyModalOpen(true);
                              }}
                            >
                              Register PK
                            </button>
                            <button
                              className="btn btn-sm btn-warning"
                              onClick={() => {
                                console.log("View Registrations clicked:");
                                console.log("activeRound:", activeRound);
                                console.log("activeRound._id:", activeRound?._id);
                                console.log("family._id:", family._id);
                                
                                if (!activeRound || !activeRound._id) {
                                  toast.error("Please select a round first");
                                  return;
                                }
                                
                                setSelectedFamily(family);
                                fetchRegisteredUsers(activeRound._id, family._id);
                                setRegisteredUsersModal(true);
                              }}
                            >
                              View Registrations
                            </button>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Pagination */}
                <div className="d-flex justify-content-center mt-3">
                  <button
                    className="btn btn-sm btn-outline-primary me-2"
                    onClick={() => {
                      const newPage = Math.max(1, familyPage - 1);
                      setFamilyPage(newPage);
                      fetchFamilies(newPage, familySearch);
                    }}
                    disabled={familyPage === 1}
                  >
                    Previous
                  </button>
                  <span className="align-self-center me-2">Page {familyPage}</span>
                  <button
                    className="btn btn-sm btn-outline-primary"
                    onClick={() => {
                      const newPage = familyPage + 1;
                      setFamilyPage(newPage);
                      fetchFamilies(newPage, familySearch);
                    }}
                  >
                    Next
                  </button>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setFamilyModalOpen(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* View Members Modal */}
      {viewMembersModalOpen && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">{selectedFamily?.name} Members</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setViewMembersModalOpen(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="input-group mb-3">
                  <input
                    type="text"
                    className="form-control"
                    placeholder="Search members..."
                    value={memberSearch}
                    onChange={(e) => setMemberSearch(e.target.value)}
                    onKeyPress={(e) => e.key === 'Enter' && handleMemberSearch()}
                  />
                  <button 
                    className="btn btn-outline-primary" 
                    type="button" 
                    onClick={handleMemberSearch}
                  >
                    <i className="fas fa-search"></i>
                  </button>
                </div>
                
                <div className="table-responsive" style={{ maxHeight: "400px", overflowY: "auto" }}>
                  <table className="table table-sm">
                    <thead>
                      <tr>
                        <th>User</th>
                        <th>Role</th>
                        <th>Level</th>
                      </tr>
                    </thead>
                    <tbody>
                      {familyMembers.map((member) => (
                        <tr key={member._id}>
                          <td>
                            <div className="d-flex align-items-center">
                              <img
                                src={member.picture || "/default-avatar.png"}
                                alt="User"
                                className="rounded-circle me-2"
                                style={{ width: "30px", height: "30px" }}
                              />
                              <span>{member.username}</span>
                            </div>
                          </td>
                          <td>
                            <span className={`badge ${member.role === 'Leader' ? 'bg-primary' : member.role === 'Co-Leader' ? 'bg-secondary' : 'bg-info'}`}>
                              {member.role}
                            </span>
                          </td>
                          <td>
                            <img src={member.level} alt="Level" style={{ width: "24px", height: "24px" }} />
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </table>
                </div>

                {/* Member Pagination Controls */}
                <div className="d-flex justify-content-between align-items-center mt-3">
                  <div className="d-flex align-items-center">
                    <label htmlFor="memberEntriesPerPage" className="me-2">
                      Members Per Page:
                    </label>
                    <select 
                      id="memberEntriesPerPage"
                      className="form-select w-auto"
                      value={memberLimit}
                      onChange={(e) => handleMemberLimitChange(parseInt(e.target.value))}
                    >
                      <option value={10}>10</option>
                      <option value={20}>20</option>
                      <option value={50}>50</option>
                    </select>
                  </div>
                  
                  <div className="d-flex align-items-center">
                    <button
                      className="btn btn-sm btn-secondary me-2"
                      disabled={memberPage === 1}
                      onClick={() => handleMemberPageChange(memberPage - 1)}
                    >
                      Previous
                    </button>
                    <span className="mx-2">
                      Page {memberPage} of {memberTotalPages} ({memberTotalCount} total)
                    </span>
                    <button
                      className="btn btn-sm btn-secondary"
                      disabled={memberPage === memberTotalPages}
                      onClick={() => handleMemberPageChange(memberPage + 1)}
                    >
                      Next
                    </button>
                  </div>
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setViewMembersModalOpen(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Register Family PK Modal */}
      {registerFamilyModalOpen && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Register {selectedFamily?.name} for PK Battle</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setRegisterFamilyModalOpen(false)}
                ></button>
              </div>
              <div className="modal-body">
                <div className="alert alert-info">
                  <strong>Current Round:</strong> {activeRound?.roundName} - Round {activeRound?.roundCount}
                </div>

                {/* Member Selection */}
                <div className="mb-3">
                  <label className="form-label">Select Members:</label>
                  <div className="input-group mb-2">
                    <input
                      type="text"
                      className="form-control"
                      placeholder="Search members..."
                      value={memberSearch}
                      onChange={(e) => setMemberSearch(e.target.value)}
                      onKeyPress={(e) => e.key === 'Enter' && handleMemberSearch()}
                    />
                    <button 
                      className="btn btn-outline-primary" 
                      type="button" 
                      onClick={handleMemberSearch}
                    >
                      <i className="fas fa-search"></i>
                    </button>
                  </div>
                  
                  <div style={{ maxHeight: "300px", overflowY: "auto" }}>
                    {familyMembers.map((member) => (
                      <div key={member._id} className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id={`member-${member._id}`}
                          checked={selectedMembers.includes(member._id)}
                          onChange={() => handleMemberSelection(member._id)}
                        />
                        <label className="form-check-label" htmlFor={`member-${member._id}`}>
                          <div className="d-flex align-items-center">
                            <img
                              src={member.picture || "/default-avatar.png"}
                              alt="User"
                              className="rounded-circle me-2"
                              style={{ width: "30px", height: "30px" }}
                            />
                            <div>
                              <div>{member.username}</div>
                              <small className="text-muted">{member.role}</small>
                            </div>
                          </div>
                        </label>
                      </div>
                    ))}
                  </div>

                  {/* Member Pagination Controls */}
                  <div className="d-flex justify-content-between align-items-center mt-3 mb-3">
                    <div className="d-flex align-items-center">
                      <label htmlFor="regMemberEntriesPerPage" className="me-2">
                        Members Per Page:
                      </label>
                      <select 
                        id="regMemberEntriesPerPage"
                        className="form-select w-auto"
                        value={memberLimit}
                        onChange={(e) => handleMemberLimitChange(parseInt(e.target.value))}
                      >
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={50}>50</option>
                      </select>
                    </div>
                    
                    <div className="d-flex align-items-center">
                      <button
                        className="btn btn-sm btn-secondary me-2"
                        disabled={memberPage === 1}
                        onClick={() => handleMemberPageChange(memberPage - 1)}
                      >
                        Previous
                      </button>
                      <span className="mx-2 small">
                        Page {memberPage} of {memberTotalPages} ({memberTotalCount} total)
                      </span>
                      <button
                        className="btn btn-sm btn-secondary"
                        disabled={memberPage === memberTotalPages}
                        onClick={() => handleMemberPageChange(memberPage + 1)}
                      >
                        Next
                      </button>
                    </div>
                  </div>
                </div>

                <div className="alert alert-info">
                  Selected members: {selectedMembers.length}
                </div>
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setRegisterFamilyModalOpen(false)}
                >
                  Cancel
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={adminRegisterPkBattle}
                  disabled={loading || selectedMembers.length === 0}
                >
                  {loading ? "Registering..." : "Register"}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Registered Users Modal */}
      {registeredUsersModal && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Registered Users - {selectedFamily?.name}</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => setRegisteredUsersModal(false)}
                ></button>
              </div>
              <div className="modal-body">
                {registeredUsers.length > 0 ? (
                  <div>
                    <div className="table-responsive" style={{ maxHeight: "400px", overflowY: "auto" }}>
                      <table className="table table-sm">
                        <thead>
                          <tr>
                            <th>User</th>
                            <th>Registration Date</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {registeredUsers.map((reg) => (
                            <tr key={reg._id}>
                              <td>
                                <div className="d-flex align-items-center">
                                  <img
                                    src={reg.user.picture || "/default-avatar.png"}
                                    alt="User"
                                    className="rounded-circle me-2"
                                    style={{ width: "30px", height: "30px" }}
                                  />
                                  <span>{reg.user.username}</span>
                                </div>
                              </td>
                              <td>{new Date(reg.registrationDate).toLocaleDateString()}</td>
                              <td>
                                <button
                                  className="btn btn-sm btn-danger"
                                  onClick={() => deleteFamilyPkRegistration(activeRound?._id, selectedFamily?._id)}
                                >
                                  Delete All
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  </div>
                ) : (
                  <div className="alert alert-info">No registrations found for this family in the current round.</div>
                )}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => setRegisteredUsersModal(false)}
                >
                  Close
                </button>
              </div>
            </div>
          </div>
        </div>
      )}

      {/* Add Registration Modal */}
      {addRegistrationModalOpen && (
        <div className="modal show d-block" tabIndex="-1">
          <div className="modal-dialog modal-xl">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title">Add Family Registration - {activeRound?.roundName}</h5>
                <button
                  type="button"
                  className="btn-close"
                  onClick={() => {
                    setAddRegistrationModalOpen(false);
                    setSelectedFamily(null);
                    setFamilyMembers([]);
                    setSelectedMembers([]);
                    setFamilySearch("");
                  }}
                ></button>
              </div>
              <div className="modal-body">
                {!selectedFamily ? (
                  /* Step 1: Family Selection */
                  <div>
                    <h6>Step 1: Select Family</h6>
                    <div className="mb-3">
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search families..."
                          value={familySearch}
                          onChange={(e) => setFamilySearch(e.target.value)}
                          onKeyPress={(e) => e.key === 'Enter' && handleFamilySearch()}
                        />
                        <button 
                          className="btn btn-outline-primary" 
                          type="button" 
                          onClick={handleFamilySearch}
                        >
                          <i className="fas fa-search"></i>
                        </button>
                      </div>
                    </div>

                    <div className="table-responsive" style={{ maxHeight: "400px", overflowY: "auto" }}>
                      <table className="table table-bordered table-striped table-hover">
                        <thead>
                          <tr>
                            <th>Family</th>
                            <th>Leader</th>
                            <th>Members</th>
                            <th>Action</th>
                          </tr>
                        </thead>
                        <tbody>
                          {families.map((family) => (
                            <tr key={family._id} style={{ cursor: "pointer" }}>
                              <td>
                                <div className="d-flex align-items-center">
                                  <img
                                    src={family.image || "/default-family.png"}
                                    alt="Family"
                                    className="rounded-circle me-2"
                                    style={{ width: "40px", height: "40px" }}
                                  />
                                  <span>{family.name}</span>
                                </div>
                              </td>
                              <td>
                                <div className="d-flex align-items-center">
                                  <img
                                    src={family.leader.picture || "/default-avatar.png"}
                                    alt="Leader"
                                    className="rounded-circle me-2"
                                    style={{ width: "30px", height: "30px" }}
                                  />
                                  <span>{family.leader.username}</span>
                                </div>
                              </td>
                              <td>
                                <span className="badge bg-primary">{family.memberCount}</span>
                              </td>
                              <td>
                                <button
                                  className="btn btn-success btn-sm"
                                  onClick={() => {
                                    setSelectedFamily(family);
                                    fetchFamilyMembers(family._id);
                                  }}
                                >
                                  Select Family
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    {/* Pagination for families */}
                    <div className="d-flex justify-content-center mt-3">
                      <button
                        className="btn btn-sm btn-outline-primary me-2"
                        onClick={() => {
                          const newPage = Math.max(1, familyPage - 1);
                          setFamilyPage(newPage);
                          fetchFamilies(newPage, familySearch);
                        }}
                        disabled={familyPage === 1}
                      >
                        Previous
                      </button>
                      <span className="align-self-center me-2">Page {familyPage}</span>
                      <button
                        className="btn btn-sm btn-outline-primary"
                        onClick={() => {
                          const newPage = familyPage + 1;
                          setFamilyPage(newPage);
                          fetchFamilies(newPage, familySearch);
                        }}
                      >
                        Next
                      </button>
                    </div>
                  </div>
                ) : (
                  /* Step 2: Member Selection */
                  <div>
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h6>Step 2: Select Members for "{selectedFamily.name}"</h6>
                      <button
                        className="btn btn-outline-secondary btn-sm"
                        onClick={() => {
                          setSelectedFamily(null);
                          setFamilyMembers([]);
                          setSelectedMembers([]);
                        }}
                      >
                        ← Back to Family Selection
                      </button>
                    </div>

                    <div className="alert alert-info">
                      <strong>Current Round:</strong> {activeRound?.roundName} - Max Members: {activeRound?.maxMembers}
                    </div>

                    <div className="mb-3">
                      <div className="input-group">
                        <input
                          type="text"
                          className="form-control"
                          placeholder="Search members..."
                          value={memberSearch}
                          onChange={(e) => setMemberSearch(e.target.value)}
                          onKeyPress={(e) => e.key === 'Enter' && handleMemberSearch()}
                        />
                        <button 
                          className="btn btn-outline-primary" 
                          type="button" 
                          onClick={handleMemberSearch}
                        >
                          <i className="fas fa-search"></i>
                        </button>
                      </div>
                    </div>

                    <div className="mb-3">
                      <div className="form-check">
                        <input
                          className="form-check-input"
                          type="checkbox"
                          id="selectAllMembers"
                          onChange={(e) => {
                            if (e.target.checked) {
                              setSelectedMembers(familyMembers.map(member => member._id));
                            } else {
                              setSelectedMembers([]);
                            }
                          }}
                          checked={selectedMembers.length === familyMembers.length && familyMembers.length > 0}
                        />
                        <label className="form-check-label" htmlFor="selectAllMembers">
                          <strong>Select All Members</strong>
                        </label>
                      </div>
                    </div>

                    <div className="table-responsive" style={{ maxHeight: "400px", overflowY: "auto" }}>
                      <table className="table table-sm">
                        <thead>
                          <tr>
                            <th>Select</th>
                            <th>User</th>
                            <th>Role</th>
                            <th>Level</th>
                          </tr>
                        </thead>
                        <tbody>
                          {familyMembers.map((member) => (
                            <tr key={member._id}>
                              <td>
                                <input
                                  className="form-check-input"
                                  type="checkbox"
                                  checked={selectedMembers.includes(member._id)}
                                  onChange={() => handleMemberSelection(member._id)}
                                />
                              </td>
                              <td>
                                <div className="d-flex align-items-center">
                                  <img
                                    src={member.picture || "/default-avatar.png"}
                                    alt="User"
                                    className="rounded-circle me-2"
                                    style={{ width: "30px", height: "30px" }}
                                  />
                                  <div>
                                    <div>{member.username}</div>
                                  </div>
                                </div>
                              </td>
                              <td>
                                <span className={`badge ${member.role === 'Leader' ? 'bg-primary' : member.role === 'Co-Leader' ? 'bg-secondary' : 'bg-info'}`}>
                                  {member.role}
                                </span>
                              </td>
                              <td>
                                <img src={member.level} alt="Level" style={{ width: "24px", height: "24px" }} />
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>

                    {/* Member Pagination Controls */}
                    {memberTotalPages > 1 && (
                      <div className="d-flex justify-content-between align-items-center mt-3">
                        <div>
                          <span className="me-3">
                            Showing {((memberPage - 1) * memberLimit) + 1} to {Math.min(memberPage * memberLimit, memberTotalCount)} of {memberTotalCount} members
                          </span>
                          <select 
                            className="form-select form-select-sm d-inline-block" 
                            style={{width: 'auto'}}
                            value={memberLimit}
                            onChange={handleMemberLimitChange}
                          >
                            <option value={10}>10 per page</option>
                            <option value={25}>25 per page</option>
                            <option value={50}>50 per page</option>
                          </select>
                        </div>
                        <div>
                          <button 
                            className="btn btn-sm btn-outline-secondary me-2" 
                            disabled={memberPage === 1}
                            onClick={() => handleMemberPageChange(memberPage - 1)}
                          >
                            Previous
                          </button>
                          <span className="me-2">
                            Page {memberPage} of {memberTotalPages}
                          </span>
                          <button 
                            className="btn btn-sm btn-outline-secondary" 
                            disabled={memberPage === memberTotalPages}
                            onClick={() => handleMemberPageChange(memberPage + 1)}
                          >
                            Next
                          </button>
                        </div>
                      </div>
                    )}

                    <div className="alert alert-success">
                      <strong>Selected members:</strong> {selectedMembers.length} / {activeRound?.maxMembers}
                    </div>
                  </div>
                )}
              </div>
              <div className="modal-footer">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={() => {
                    setAddRegistrationModalOpen(false);
                    setSelectedFamily(null);
                    setFamilyMembers([]);
                    setSelectedMembers([]);
                    setFamilySearch("");
                  }}
                >
                  Cancel
                </button>
                {selectedFamily && (
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={adminRegisterPkBattle}
                    disabled={loading || selectedMembers.length === 0}
                  >
                    {loading ? "Registering..." : `Register ${selectedMembers.length} Members`}
                  </button>
                )}
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default PKBattleComponent;
